import React, { Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  fetchGetProductsPriceMarginHistory,
  resetGetProductMargin,
  resetGetProductsPriceMarginHistory,
} from '../../actions/items';
import InputWrapper from '../common/InputWrapper';
import NumericInput from 'react-numeric-input';
import { fetchGetProductMargin } from './../../actions/items';
import { toast } from 'react-toastify';
import SpinnerBlock from '../common/SpinnerBlock';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const MarginSalesBlock = (props) => {
  const { values, handleChangeInput, productId, variantId, title } = props;

  const { t } = useAutoTranslation();

  const dispatch = useDispatch();

  const marketplaceCosts = useSelector((state) => state.auth.account.marginParams.marketplaceCosts);
  const { priceSettings } = useSelector((state) => state.settings);

  const [isHistoryLoading, setIsHistoryLoading] = useState(false);
  const [isMarginChartLoading, setIsMarginChartLoading] = useState(false);

  const averagePrice = priceSettings.filter((price) => price.name === 'Средняя цена закупки');

  useEffect(() => {
    return async () => {
      await dispatch(resetGetProductMargin());
      await dispatch(resetGetProductsPriceMarginHistory());
    };
  }, [dispatch]);

  const handleCosts = (e) => {
    const key = e.target.name;
    let value = parseInt(e.target.value);
    handleChangeInput(key, value);
  };

  const handleMarketplaceCosts = (e) => {
    const { name, value } = e.target;

    let marketplaceCosts = values.marketplaceCosts;
    if (!marketplaceCosts) marketplaceCosts = [];

    const idx = marketplaceCosts?.findIndex((item) => item.marketplace === name);

    if (idx >= 0) {
      marketplaceCosts[idx].costPercent = value === '' ? value : parseInt(value);
      marketplaceCosts[idx].marketplace = name;
    } else {
      marketplaceCosts.push({
        costPercent: typeof value === '' ? value : parseInt(value),
        marketplace: name,
      });
    }

    handleChangeInput('marketplaceCosts', marketplaceCosts);
  };

  const getValueByName = (name) => {
    const idx =
      values.marketplaceCosts &&
      values.marketplaceCosts.findIndex((item) => item.marketplace === name);

    if (idx >= 0) {
      return values.marketplaceCosts?.[idx]?.costPercent;
    } else {
      return 0;
    }
  };

  const handleMarginSalesHistory = async () => {
    setIsHistoryLoading(true);
    const result = await dispatch(fetchGetProductsPriceMarginHistory(variantId));

    if (result?.history?.length === 0) {
      toast.info(t('Нет истории изменений средней закупочной цены'));
    }

    if (result?.errors?.[0]?.message) {
      toast.error(result.errors[0].message);
    }
    setIsHistoryLoading(false);
  };

  const handleMarginSalesChart = async () => {
    setIsMarginChartLoading(true);
    if (variantId) {
      let resultDelivered, resultShipped;
      try {
        await dispatch(fetchGetProductMargin(variantId, true));
        await dispatch(fetchGetProductMargin(variantId, false));
      } catch (error) {
        if (error.data.errors?.[0]?.message) {
          toast.error(error.data.errors[0].message);
        }
      }
    }

    setIsMarginChartLoading(false);
  };

  const handleChangePrice = (value, priceType) => {
    const isExist = Boolean(values.prices[priceType?.code]);
    const newPrice = isExist
      ? {
          ...values.prices[priceType?.code],
          value,
        }
      : {
          priceCode: priceType?.code,
          priceName: priceType?.name,
          value,
        };

    handleChangeInput('prices', {
      ...values.prices,
      [priceType?.code]: newPrice,
    });
  };

  return (
    <Fragment>
      <div className="border-bottom" style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h4 className="header-title">{t(title)}</h4>
        <a
          style={{ fontSize: '15.2px' }}
          href="https://kak2c.ru/blog/post/v-lichnom-kabinete-kaktusa-poyavilsya-instrument-avtorascheta-marzhinalnosti-prodazh"
          rel="noopener"
          target="_blank"
        >
          {t('Справка')}
        </a>
      </div>
      <div className="row">
        <div className="col-12">
          <h5 className="mb-0">{t('Затраты')}</h5>
          <p className="mt-1 mb-3" style={{ fontSize: '12px', color: '#98a6ad' }}>
            {t('Доля в % от цены продажи товара и/или затраты в рублях на ед. товара')}
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-sm-6 col-md-4">
          <InputWrapper
            type="number"
            label={t('Складская логистика')}
            name="fulfillmentCost"
            value={values.fulfillmentCost}
            textAppend="&#8381;"
            onChange={(e) => handleCosts(e)}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-12">
          <h5 className="mb-2">{t('Тарифы и комиссии маркетплейсов')}</h5>
        </div>
      </div>
      <div className="row">
        {marketplaceCosts &&
          marketplaceCosts.map((item) => {
            return (
              <div className="col-12 col-sm-6">
                <div className="form-group">
                  <InputWrapper
                    label={item.marketplace}
                    textAppend="&#37;"
                    name={item.marketplace}
                    type="number"
                    value={getValueByName(item.marketplace)}
                    onChange={(e) => handleMarketplaceCosts(e)}
                  />
                </div>
              </div>
            );
          })}
      </div>
      <div className="row">
        <div className="col-12 col-sm-6 col-md-4">
          <InputWrapper
            label={t('Прочие расходы')}
            textAppend="&#8381;"
            type="number"
            name="otherCost"
            value={values.otherCost}
            onChange={(e) => handleCosts(e)}
          />
        </div>
      </div>
      <div className="row">
        <div className="form-group">
          <p style={{ marginLeft: '12px' }} className="mb-0 mt-1">
            <i>* {t('Все указанные затраты суммируются')}</i>
          </p>
        </div>
      </div>

      {productId ? (
        <>
          <div key={averagePrice[0]?.code} className="row">
            <div className="col-12 col-sm-6 col-md-4">
              <div className="form-group">
                <InputWrapper
                  type="number"
                  label={t(averagePrice[0]?.name)}
                  id={averagePrice[0]?.code}
                  value={
                    values.prices[averagePrice[0]?.code]
                      ? values.prices[averagePrice[0]?.code].value
                      : ''
                  }
                  onChange={(value) => handleChangePrice(value, averagePrice[0])}
                  textAppend="&#8381;"
                  placeholder={t('Введите цену')}
                  component={NumericInput}
                  componentProps={{ precision: 2, style: false }}
                />
              </div>
            </div>
          </div>

          <div className="row" style={{ position: 'relative' }}>
            <p
              style={{ cursor: 'pointer', color: '#7e57c3', marginLeft: '12px' }}
              onClick={handleMarginSalesHistory}
            >
              {t('Отобразить историю изменений средней закупочной цены')}
            </p>
            <SpinnerBlock
              show={isHistoryLoading || isMarginChartLoading}
              style={{ left: '-5%', top: '12px' }}
            />
          </div>

          <div className="row">
            <p
              style={{ cursor: 'pointer', color: '#7e57c3', marginLeft: '12px' }}
              onClick={handleMarginSalesChart}
            >
              {t('Отобразить график маржинальности товара')}
            </p>
          </div>
        </>
      ) : null}
    </Fragment>
  );
};

export default MarginSalesBlock;
